import { CanActivateFn, Router } from '@angular/router';
import { AppSubscription, AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import moment from 'moment';
import { map } from 'rxjs';
import { SubscriptionLevels } from '../models/subscription-levels';

export const subscriptionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getSubscription()
    .pipe(
      map((subscription: AppSubscription) => {
        const subscriptionActive = (subscription.subscriptionLevel == SubscriptionLevels.Trial && moment().isBefore(subscription.subscriptionExpiration)) ||
          subscription.subscriptionLevel == SubscriptionLevels.Lite || subscription.subscriptionLevel == SubscriptionLevels.Advanced;

        if (subscriptionActive) {
          return true;
        }
        else {
          router.navigate(['/subscription']);
          return false;
        }
    }));
};
